const styles = (theme) => ({
  iframeContainer: {
    width: '100%',
    border: 0,
    overflow: 'hidden',
  },
});

export default styles;
